import { BaseInput } from './shared/base-input';

export function SearchBar({
  useContextFn,
  placeHolder,
  style,
  label,
  height,
}: {
  useContextFn: () => {
    q: string;
    setQ: (value: string) => void;
  };
  label?: string;
  placeHolder?: string;
  style?: Record<string, Record<string, string> | string>;
  height?: string;
}) {
  const { q, setQ } = useContextFn();
  return (
    <BaseInput
      label={label}
      style={style}
      placeHolder={placeHolder}
      q={q ?? ''}
      writeQ={setQ}
      height={height}
    />
  );
}
